export const ENDPOINTS = {
    FETCH_REPORT_DATA: "/webapi/resultados/data-table",
};
